import useHasMounted from '@/hooks/useHasMounted';
import { useAtom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';
import { useEffect } from 'react';

export const bannerAtom = atomWithStorage('bannerState_unriddleToAnara', -1);

const Banner = () => {
  const [showBanner, setShowBanner] = useAtom(bannerAtom);
  const hasMounted = useHasMounted();

  useEffect(() => {
    const cookie = document.cookie
      .split('; ')
      .find((row) => row.startsWith('showUnriddleBannerUntil='));
    if (cookie && hasMounted) {
      const showBannerUntil = Number.parseInt(cookie.split('=')[1]);
      if (showBannerUntil > Date.now() && showBanner === -1) {
        setShowBanner(1);
      }
      if (showBannerUntil < Date.now()) {
        setShowBanner(-1);
      }
    }
  }, [showBanner, hasMounted]);

  const handleClose = () => {
    setShowBanner(0);
  };

  if (showBanner !== 1 || !hasMounted) return null;

  return (
    <div className="left-0 top-0 sticky w-full text-center h-9 max-sm:text-xs text-badgeBlue text-sm font-semibold bg-badgeLightBlue p-2 z-[49] flex justify-between items-center">
      <div className="text-center flex-grow">
        <span>
          {/* We're investigating an outage with one of our core service providers.
          Some features might be unavailable. */}
          Unriddle is now Anara.{' '}
          <a
            href="https://www.notion.so/unriddle/The-beginning-of-a-new-story-1b35161d763180039594db7b6be74e8e"
            className="underline"
            target="_blank"
            rel="noopener noreferrer"
          >
            Learn more
          </a>
          .
        </span>
      </div>
      <button
        onClick={handleClose}
        className="bg-transparent border-none cursor-pointer p-2 text-xl font-medium"
      >
        &times;
      </button>
    </div>
  );
};

export default Banner;
